import React from "react";
import { GridCell, gridConstants, GridContainer } from "../Grid";
import hero from "../../images/FIMC-VI-logo.svg";

interface LayoutHeroProps {
    children?: React.ReactNode;
}

export const LayoutHero: React.FC<LayoutHeroProps> = ({ children }: LayoutHeroProps) => {
    return <>
        <GridContainer hasMarginY>
            <GridCell medium_columns={gridConstants.column.THREE} large_columns={gridConstants.column.FOUR}
                      className={gridConstants.class.HIDE_SMALL}>
                <div className="logo__container">
                    <img src={hero} title={`FIMC-VI logo`} alt={`FIMC-VI`}/>
                </div>
            </GridCell>
            <GridCell medium_columns={gridConstants.column.NINE} large_columns={gridConstants.column.EIGHT}>
                {children}
            </GridCell>
        </GridContainer>
        <br/>
        <br/>
        <br/>
    </>;
};
